import {create} from 'zustand';
import {Step} from '../../../../../../shared/types/form.types';

export interface StepStore {
  steps: Step[];

  update: (steps: Step[]) => void;
  reset: () => void;
}

export const useStepStore = create<StepStore>((set) => ({
  steps: [],

  update: (steps) => {
    set({steps});
  },

  reset: () =>
    set({
      steps: [],
    }),
}));
